"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    media: {
        height: 350,
        width: '100%',
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            height: 300
        }
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 0,
        height: '100%',
        width: '100%',
        paddingBottom: '0 !important'
    },
    winningNumberContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    winningNumber: {
        border: '1px solid',
        borderRadius: 20,
        width: 40,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: theme.spacing() / 2
    },
    innerContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: '50%',
        justifyContent: 'center'
    },
    lowerContent: {
        backgroundColor: theme.palette.grey[50]
    }
});
exports.default = styles;
//# sourceMappingURL=DrawGameCardStyle.js.map